'use client';

import { useEffect } from 'react';
import { usePublicClient } from 'wagmi';
import { useSelectedRpc } from './useSelectedRpc';

export function useRpcPatcher(chainId?: number, selectedRpc?: string) {
  const publicClient = usePublicClient({ chainId });
  
  useEffect(() => {
    if (!chainId || !selectedRpc || !publicClient) {
      return;
    }
    
    // Get internal config
    const configInternal = (publicClient as any).config;
    if (!configInternal?.transports) {
      return;
    }
    
    // Create new transport for selected RPC
    const newTransport = {
      url: selectedRpc,
      type: 'http' as const,
      retryCount: 2,
      retryDelay: 1000,
      batch: true
    };
    
    // Update transport
    configInternal.transports = {
      ...configInternal.transports,
      [chainId]: newTransport
    };
    
    // Clear cached clients
    if ((publicClient as any).clearCache) {
      (publicClient as any).clearCache();
    }
    
    // Force refresh
    window.dispatchEvent(new CustomEvent('wagmi-refresh'));
    
  }, [chainId, selectedRpc, publicClient]);
} 